'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PrefetchData = ({
  children
}) => {
  const {
    loading: themeLoading
  } = nthHookTheme.useThemeX();
  const {
    loading: translationsLoading
  } = nthHookTranslations.useTranslationsX();
  if (translationsLoading || themeLoading) return null;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
var PrefetchData$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(PrefetchData, {
  themeTokens: ['alertNoneNone', 'bodytextDefaultNone', 'buttonsDismissNone', 'buttonsPrimaryDefault', 'buttonsPrimaryDisabled', 'buttonsPrimaryHover', 'buttonsSecondaryDefault', 'buttonsSecondaryDisabled', 'buttonsSecondaryHover', 'dividerPrimaryNone', 'iconsPrimaryNone', 'inputtextinputsNoneNone', 'linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['giftTrackingBannerMessage', 'giftTrackingBannerLink', 'giftTrackingSharingMessageBody', 'giftTrackingSharingMessageSubject', 'giftTrackingSendEmailPrompt', 'giftTrackingSendEmailButtonText', 'giftTrackingCopyLinkPrompt', 'giftTrackingCopyLinkSuccessMessage']
});

exports["default"] = PrefetchData$1;
